export default {
  name: 'trustFunctions',
  methods: {
    trustFillAddressValues(id, onChange, address) {
      const event = {
        detail: {
          address,
        },
      };

      const line1Element = document.getElementById(`${id}-addressLine1`);
      line1Element.value = event.detail.address.addressLine1;
      line1Element.dispatchEvent(new Event('change'));

      document.getElementById(`${id}-addressLine2`).value = event.detail.address.addressLine2;

      const cityNameElement = document.getElementById(`${id}-cityName`);
      cityNameElement.value = event.detail.address.cityName;
      cityNameElement.dispatchEvent(new Event('change'));

      const stateCodeElement = document.getElementById(`${id}-stateCode`);
      stateCodeElement.value = event.detail.address.stateCode;
      stateCodeElement.dispatchEvent(new Event('change'));

      const zipCodeElement = document.getElementById(`${id}-zipCode`);
      zipCodeElement.value = event.detail.address.zipCode;
      zipCodeElement.dispatchEvent(new Event('change'));
      // todo add to data store here

      onChange(event);
    },
  },

};
